//import sanityClient from "@sanity/client"
const { createClient } = require('@sanity/client')

const client = createClient({
  projectId: process.env.GATSBY_SANITY_PROJECT_ID,
  dataset: process.env.GATSBY_SANITY_DATASET,
  apiVersion: '2021-11-29',
  useCdn: true
})

module.exports = client
